import axios from "axios";
import {message} from "antd";

const RECEIVE_MESSAGE_UPDATE = "receiveMessage/RECEIVE_MESSAGE_UPDATE";
const RECEIVE_MESSAGE_LOADING = "receiveMessage/RECEIVE_MESSAGE_LOADING";
const RECEIVE_MESSAGE_LIST = "receiveMessage/RECEIVE_MESSAGE_LIST";
const RECEIVE_MESSAGE_APPLIST = "receiveMessage/RECEIVE_MESSAGE_APPLIST";
const RECEIVE_MESSAGE_TYPELIST = "receiveMessage/RECEIVE_MESSAGE_TYPELIST";

export const receiveMessage = (state = {
                                     loading: false,
                                     app:"",
                                     appList:[],
                                     page:0,
                                     size:10,
                                     total:0,
                                     messageList:[],
                                     title:"",
                                     selectMessageTypes:[],
                                     messageTypeList:[],
                                     ifRead:"true,false",
                                     importance:"importance,normal",
                                     ifHide:true,
                                     //orderTitle:"descend",
                                     orderTime:"descend",
                                   }, action) => {
  switch (action.type) {
    case RECEIVE_MESSAGE_UPDATE:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case RECEIVE_MESSAGE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    case RECEIVE_MESSAGE_APPLIST:
      return {
        ...state,
        appList: action.data
      };
    case RECEIVE_MESSAGE_TYPELIST:
      return {
        ...state,
        messageTypeList: action.data,
        selectMessageTypes:[],
        title:""
      };
    case RECEIVE_MESSAGE_LIST:
      return {
        ...state,
        messageList: action.data.content,
        page:action.data.number,
        size:action.data.size,
        total:action.data.totalElements,
        loading:false
      };
    default:
      return state;
  }
};

/**
 * update data
 */
export const update = (data) => {
  return {
    type: RECEIVE_MESSAGE_UPDATE,
    data: data
  }
};

/**
 * loading
 */
export const toggleLoading = (show) => {
  return {
    type: RECEIVE_MESSAGE_LOADING,
    data: show
  }
};

export const getAppList = (enterprise , role , userId) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios(`/api-user/getApps?enterprise=${enterprise}&roleId=${role}&userId=${userId}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        let apps = response.data;
        if(apps.length > 0){
          let a = [];
          apps.map(function (e) {
            a.push(e.appId)
          });
          apps = [{appId:a.toString(),appName:"全部"} , ...apps ];
        }
        dispatch(update({name:"appList",value:apps}));
        dispatch(update({name:"app",value:(apps.length > 0 ? apps[0].appId : "")}));
        if(apps.length > 0){
          //dispatch(getMessageTypeList({appId:apps[0].appId ,enterpriseId:enterprise}));
          dispatch(getMessageList({userId:userId,appId:apps[0].appId ,enterpriseId:enterprise,title:"",selectMessageTypes:[],ifRead:"true,false",importance:"importance,normal",page:0,size:10,ifHide:false,orderTime:"descend",}));
        }
        else{
          dispatch(toggleLoading(false));
        }
      }
    }
  ).catch(
    error => {
    });
};

export const getMessageTypeList = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios(`/api-message/notificationTypes?appId=${data.appId}&name=&enterprise=${data.enterpriseId}&page=0&size=1000`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeMessageTypeList(response.data));
      }
    }
  ).catch(
    error => {
    });
};

/**
 * store all App列表
 */
export const storeMessageTypeList = (data) => {
  return {
    type: RECEIVE_MESSAGE_TYPELIST,
    data: data.content
  }
};

export const getMessageList = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios(`/api-message/message/notifications/${data.userId}?appId=${data.appId}&title=${data.title}&enterpriseId=${data.enterpriseId}&type=${data.selectMessageTypes}&read=${data.ifRead}&importance=${data.importance}&page=${data.page}&size=${data.size}&ifDelete=${data.ifHide}&orderTime=${data.orderTime}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeMessageList(response.data));
      }
    }
  ).catch(
    error => {
      dispatch(toggleLoading(false));
    });
};

/**
 * store all message列表
 */
export const storeMessageList = (data) => {
  return {
    type: RECEIVE_MESSAGE_LIST,
    data: data
  }
};


